<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="column screen-width" style="gap: 40px; padding: 60px 0px">
            <p style="font-size: 32px; font-weight: bold">비밀번호 변경</p>

            <div class="login-view align-center column">
                <div class="input-user column align-center">
                    <div class="row align-space-between" style="width:100%">
                         <p style="font-size: 28px; font-weight: bold"> 새 비밀번호</p>
                        <input
                            v-model="password"
                            class="input-form"
                            type="password"
                            @click="target = 0"
                            @input="validatePassword"
                        />
                    </div>
                    <p v-if="passwordError" class="error-text">{{ passwordError }}</p>

                    <div class="row align-space-between" style="width:100%">
                        <p style="font-size: 28px; font-weight: bold"> 비밀번호 확인 </p>
                        <input
                            v-model="passwordCheck"
                            class="input-form"
                            type="password"
                            @click="target = 1"
                            @input="checkPasswordMatch"
                        />
                    </div>
                    <p v-if="passwordCheckError" class="error-text">{{ passwordCheckError }}</p>

                </div>

                <div class="button">
                    <v-btn color="info" width="600" height="70%" @click="resetPassword">
                        비밀번호 변경
                    </v-btn>
                </div>

            </div>
        </div>
    </v-container>
</template>

<script>
import { useStore } from "vuex";
import { useRouter,useRoute } from "vue-router";
import { ref, computed, onMounted } from "vue";

export default {
    components: {},
    setup() {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        
        const password = ref("");
        const passwordCheck = ref("");
        const result = ref(null);
        // 에러 메시지
        const passwordError = ref("");
        const passwordCheckError = ref("");


         const token = computed(() => {
            return route.query.token;
        }); 

        const resetPassword = () => {
            if (!isAccess.value) {
                alert("비밀번호를 정확히 입력해주세요.");
                return; 
            }
            store.dispatch("resetPassword", {
                password: password.value,
                token: token.value
            }).then((res) => {
                result.value = res;
                alert("비밀번호가 변경되었습니다.");
                router.replace({path: "/login"});
            }).catch((err) => {
                result.value = err;
                alert("비밀번호 변경 시간이 만료되었습니다. 다시 시도해주세요.")
                router.back();
            })
        }

        // 비밀번호 유효성 검사
        const validatePassword = () => {
            if (password.value.length < 6) {
                passwordError.value = "비밀번호는 최소 6자리 이상이어야 합니다.";
            } else {
                passwordError.value = "";
            }
        };

        // 비밀번호 확인 검사
        const checkPasswordMatch = () => {
            if (password.value !== passwordCheck.value) {
                passwordCheckError.value = "비밀번호가 일치하지 않습니다.";
            } else {
                passwordCheckError.value = "";
            }
        };

        // 모든 필드가 입력되었는지 확인
        const isAccess = computed(() => {
            return (
                password.value.length >= 6 &&
                password.value === passwordCheck.value
            );
        });

        onMounted(() => {
        })

        return {
            passwordCheck,
            password,
            resetPassword,
            checkPasswordMatch,
            validatePassword,
            passwordError,
            passwordCheckError,
            isAccess
        };
    },
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: relative;
    z-index: 1;
}
.container::after {
    content: "";
    width: 25%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: absolute;
    /* background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ),
    url(@/assets/background_img.jpg); */
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
    opacity: 0.6;
}
.login-view {
    width: 100%;
    height: 500px;
    background: white;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    gap:24px;
}

.logo-view {
    width: 100%;
    text-align: center;
    height: 45%;
}

.input-user {
    width: 50%;
    text-align: center;
    height: auto;
}

.input-form {
    width: 60%;
    border: 1px solid black;
    height: 64px;
    margin: 10px;
    text-indent: 15px;
}

.button {
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
}

.error-text {
    margin-left: calc(40% + 20px);
    margin-right:auto;
    color: red;
    font-size: 18px;
    margin-top: -10px;
}
</style>
